import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { ClipboardList, X, Plus } from "lucide-react";
import { WORKER_DOC_CATEGORIES, COMPANY_DOC_CATEGORIES } from "../lib/utils-app";

export default function RequiredDocsPanel() {
  const [req, setReq] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/required-docs").then(r => setReq(r.data)); }, []);
  if (!req) return null;

  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/settings/required-docs", req); setReq(data); toast.success("Checklist salvata"); }
    catch { toast.error("Errore salvataggio"); } finally { setBusy(false); }
  };
  const remove = (k, c) => setReq({ ...req, [k]: req[k].filter(x => x !== c) });
  const add = (k, c) => { if (c && !req[k].includes(c)) setReq({ ...req, [k]: [...req[k], c] }); };

  return (
    <section className="space-y-3" data-testid="required-docs-panel">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-lg font-semibold text-slate-900 flex items-center gap-2"><ClipboardList size={18} /> Documenti obbligatori (stato MANCANTE)</h2>
          <p className="text-sm text-slate-500">Checklist usata per segnalare i documenti mancanti per ogni azienda e lavoratore attivo.</p>
        </div>
        <button onClick={save} disabled={busy} data-testid="required-docs-save" className="bg-slate-900 hover:bg-slate-800 text-white px-4 py-2 rounded-lg text-sm font-medium disabled:opacity-60">Salva checklist</button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[["worker", "Per ogni lavoratore", WORKER_DOC_CATEGORIES], ["company", "Per ogni azienda", COMPANY_DOC_CATEGORIES]].map(([k, l, cats]) => (
          <div key={k} className="bg-white border border-slate-200 rounded-lg p-4">
            <div className="text-xs font-mono uppercase tracking-widest text-blue-700 mb-2">{l}</div>
            <div className="flex flex-wrap gap-1.5 mb-3 min-h-[2rem]">
              {req[k].map(c => (
                <span key={c} className="inline-flex items-center gap-1 bg-slate-900 text-white rounded-full pl-3 pr-1.5 py-1 text-xs" data-testid={`req-${k}-item`}>
                  {c}<button onClick={() => remove(k, c)} className="hover:bg-slate-700 rounded-full p-0.5"><X size={12} /></button>
                </span>
              ))}
              {req[k].length === 0 && <span className="text-xs text-slate-400">Nessun documento obbligatorio</span>}
            </div>
            <AddRow options={cats.filter(c => !req[k].includes(c))} onAdd={(c) => add(k, c)} testid={`req-${k}-add`} />
          </div>
        ))}
      </div>
    </section>
  );
}

function AddRow({ options, onAdd, testid }) {
  const [v, setV] = useState("");
  const [custom, setCustom] = useState("");
  return (
    <div className="flex gap-2">
      <select value={v} onChange={(e) => setV(e.target.value)} className="flex-1 px-2 py-1.5 border border-slate-300 rounded-lg text-sm" data-testid={testid}>
        <option value="">— aggiungi categoria —</option>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
        <option value="__custom__">Personalizzata…</option>
      </select>
      {v === "__custom__" && <input value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Nome categoria" className="flex-1 px-2 py-1.5 border border-slate-300 rounded-lg text-sm" />}
      <button type="button" onClick={() => { onAdd(v === "__custom__" ? custom.trim() : v); setV(""); setCustom(""); }} className="px-2 py-1.5 border border-slate-300 rounded-lg text-sm inline-flex items-center gap-1"><Plus size={14} /></button>
    </div>
  );
}
